import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ServiceImplementationState } from "./model";

let state: ServiceImplementationState = {
  serviceImplementation: {
    id: '',
    controllerId: '',
    serviceComponentModelId: '',
    serviceComponentModelName: '',
    localId: '',
    remarks: null,
    deviceId: null,
    status: null,
    publishing: '',
    eventImplementationsCount: 0,
    triggerImplementationsCount: 0,
  },
  serviceImplementations: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ServiceImplementationState, RootStateType>;
